import React from "react";
import {
  Input,
  Space,
  Radio,
  Modal,
  Table,
  Button,
  Select,
  Tag,
  List,
} from "antd";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { TableOutlined, SearchOutlined } from "@ant-design/icons";
import { DATA } from "../myanfinviz";
import { COLUMNS } from "./constants";
import ReactDragListView from "react-drag-listview";
import * as _ from "lodash";
import { Collapse } from "antd";
import { template } from "lodash";

const { Panel } = Collapse;
const { Option } = Select;
const defaultColumns = [
  "ID",
  "Type Of Investment",
  "Name Of Investor",
  "Company Name In Myanmar",
  "Type Of Investment Business",
  "Sector",
  "Number Of Local Employees",
  "Number Of Foreign Employees",
  // "ID",
  // "Type Of Investment",
  // "Name Of Investor",
  // "Name of Principal Organization",
  // "Place of Incorporation",
  // "Company Name In Myanmar",
  // "Financial Year From",
  // "Financial Year To",
  // "Permit Number",
  // "Permit Date",
  // "Meeting Number",
  // "Meeting Date",
  // "Sector",
  // "Type Of Investment Business",
  // "Amount Of Foreign Capital USD (in Millions)",
  // "Total Amount Of Capital (in Millions)",
  // "Currency Of Total Amount",
  // "Period For Bringing in Foreign Capital (in years)",
  // "Validity Of Investment Permit (in Years)",
  // "Investing Country",
  // "Form Of Investment",
  // "Land Owner",
  // "Land Area (units not specified in file)",
  // "Lease Term",
  // "Annual Lease Fee",
  // "Land Use Premium",
  // "Number Of Local Employees",
  // "Number Of Foreign Employees",
  // "Status",
  // "Investor Address",
  // "Organization Address",
  // "Investment Permitted Address",
];

const GROUP_BY_COLUMNS = [
  "ID",
  "Type Of Investment",
  "Name Of Investor",
  "Name of Principal Organization",
  "Place of Incorporation",
  "Company Name In Myanmar",
  "Financial Year From",
  "Financial Year To",
  "Permit Number",
  "Permit Date",
  "Meeting Number",
  "Meeting Date",
  "Sector",
  "Type Of Investment Business",
  "Amount Of Foreign Capital USD (in Millions)",
  "Total Amount Of Capital (in Millions)",
  "Currency Of Total Amount",
  "Period For Bringing in Foreign Capital (in years)",
  "Validity Of Investment Permit (in Years)",
  "Investing Country",
  "Form Of Investment",
  "Land Owner",
  "Land Area (units not specified in file)",
  "Lease Term",
  "Annual Lease Fee",
  "Land Use Premium",
  "Number Of Local Employees",
  "Number Of Foreign Employees",
  "Status",
  "Investor Address",
  "Organization Address",
  "Investment Permitted Address",
];

const TABLE_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
};

export default class TableView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableSize: TABLE_SIZES.SMALL,
      isModalVisible: false,
      searchText: "",
      searchedColumn: "",
      data: [...DATA],
      columns: [...COLUMNS],
      currentPathName: "",
      selectedColumns: [
        ..._.map(
          _.pick(
            _.keyBy(COLUMNS, (k) => k.title),
            [...defaultColumns]
          )
        ),
      ],
    };
    const that = this;
    this.dragProps = {
      onDragEnd(fromIndex, toIndex) {
        const columns = [...that.state.selectedColumns];
        const item = columns.splice(fromIndex, 1)[0];
        columns.splice(toIndex, 0, item);
        that.setState({
          selectedColumns: columns,
        });
      },
      nodeSelector: "th",
    };
  }

  componentDidMount = () => {
    console.log("cDM", window.location.pathname);
    const columnsOnPath = global.localStorage.getItem(window.location.pathname);
    const tempColumns = columnsOnPath && columnsOnPath.split(",");
    console.log("cDM tempColumns", tempColumns);
    this.setState({
      currentPathName: window.location.pathname,
    });

    if (tempColumns) {
      this.setSelectedColumns(tempColumns);
    }
  };
  onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  setSelectedColumns = (selectedColumns) => {
    console.log("selectedColumns", selectedColumns);
    console.log("selectedColumn", window.location.pathname);
    this.setState({
      selectedColumns: [
        ..._.map(
          _.pick(
            _.keyBy(COLUMNS, (k) => k.title),
            [...selectedColumns]
          )
        ),
      ],
    });
  };

  showModal = () => {
    this.setModalVisible(true);
  };

  handleOk = () => {
    this.setModalVisible(false);
  };

  handleCancel = () => {
    this.setModalVisible(false);
  };

  setModalVisible = (val) => {
    this.setState({ isModalVisible: val });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  clearAll = (clearFilters) => {
    console.log("TableView clearAll clearFilters", clearFilters);
    this.setState({
      searchText: "",
      searchedColumn: "",
      data: [...DATA],
    });
  };

  groupByOnChange = (value) => {
    // console.log(`selected ${value}`);
    // const { data } = this.state;
    // const newData = _.groupBy(DATA, (r) => r[value]);
    // console.log("groupByOnChange", Object.keys(newData).length, newData);
    const win = window.open("/tables/" + value);
    win.focus();
  };

  groupByOnSearch = (val) => {
    console.log("search:", val);
  };

  render() {
    const { columns, selectedColumns, isModalVisible, tableSize } = this.state;
    console.log([..._.map(columns, (e) => `\"${e.title}\"`)].join(","));
    console.log("TableView state", this.state);
    console.log("TableView params", this.props);
    const path = global.localStorage.getItem(this.state.currentPathName);
    console.log("localStorage path", path);
    let tempColumns = path && path.split(",");
    console.log("localStorage tempColumns", typeof tempColumns, tempColumns);

    if (
      this.props &&
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.column &&
      !this.props.match.params.key
    ) {
      const groupByColumn = this.props.match.params.column;
      const newData = _.orderBy(
        _.groupBy(DATA, (r) => {
          return r[groupByColumn];
        }),
        (o) => o.length,
        "desc"
      );
      console.log("TableView else newData", newData);
      return (
        <div>
          <h2>
            Table Groups: <span className="text-warning">{groupByColumn}</span>{" "}
            | Size:{" "}
            <span className="text-success">{Object.keys(newData).length}</span>
          </h2>
          <List
            size="small"
            bordered
            dataSource={[..._.map(newData, (o) => o)]}
            renderItem={(item, i) => {
              const groupSize = item.length;
              const groupByColumnVal = item[0][groupByColumn];
              return (
                <List.Item key={i}>
                  <Space>
                    <Link
                      target={"_blank"}
                      to={`/tables/${groupByColumn}/${
                        item && item[0][groupByColumn]
                      }`}
                    >
                      <span>
                        {groupByColumnVal && groupByColumnVal != "-" ? (
                          groupByColumnVal
                        ) : (
                          <span className="text-danger">Unknown</span>
                        )}
                      </span>
                    </Link>
                    <Tag color="red">{groupSize}</Tag>
                  </Space>
                </List.Item>
              );
            }}
          />
        </div>
      );
    } else {
      let data = [];
      const hasKey =
        this.props &&
        this.props.match &&
        this.props.match.params &&
        this.props.match.params.column &&
        this.props.match.params.key;
      let groupByColumn = "";
      let groupByColumnKey = "";
      if (hasKey) {
        groupByColumn = this.props.match.params.column;
        groupByColumnKey = this.props.match.params.key;
        const groupByData = _.groupBy(DATA, (r) => {
          return r[groupByColumn];
        });
        data = groupByData[this.props.match.params.key];
      } else {
        data = [...DATA];
      }

      return (
        <div>
          <Space>
            <Button
              onClick={() => {
                this.setModalVisible(true);
              }}
              icon={<TableOutlined />}
              type="primary"
            >
              Configure
            </Button>
            {!(this.props && this.props.match && this.props.match.params) ? (
              <Select
                showSearch
                style={{ width: 300 }}
                placeholder="Group By"
                optionFilterProp="children"
                onChange={this.groupByOnChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {_.map(GROUP_BY_COLUMNS, (r, i) => (
                  <Option key={`${r}-${i}`} value={r}>
                    {r}
                  </Option>
                ))}
              </Select>
            ) : null}
            Table Size: <Tag color="red">{data && data.length}</Tag>
            {hasKey ? (
              <span>
                Grouped By: <Tag color={"volcano"}>{groupByColumn}</Tag>
              </span>
            ) : null}
            {hasKey ? (
              <span>
                Selected Group: <Tag color={"magenta"}>{groupByColumnKey}</Tag>
              </span>
            ) : null}
          </Space>
          <p className="mt-2">
            You can drag the columns to your desired position :)
          </p>
          <ReactDragListView.DragColumn {...this.dragProps}>
            <Table
              showHeader={true}
              size={tableSize}
              className="overflow-auto"
              rowKey={(record) => record["ID"]}
              bordered={true}
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                showTitle: true,
                pageSize: 100,
                showQuickJumper: true,
              }}
              columns={[
                ..._.map(selectedColumns, (e) => {
                  return { ...e, ...this.getColumnSearchProps(e.dataIndex) };
                }),
              ]}
              dataSource={data}
              onChange={this.onChange}
            />
          </ReactDragListView.DragColumn>
          <Modal
            width={"75%"}
            title="Configure Table"
            visible={isModalVisible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <h3>Columns</h3>
            <Select
              mode={"multiple"}
              className="mb-4"
              mode="multiple"
              style={{ width: "75%" }}
              placeholder="Please select"
              defaultValue={[..._.map(selectedColumns, (e) => e.title)]}
              onChange={(e) => {
                console.log("TableView onChange Select", e);
                global.localStorage.setItem(this.state.currentPathName, e);
                this.setSelectedColumns(e);
              }}
            >
              {_.map(COLUMNS, (e) => {
                return <Option key={e.title}>{e.title}</Option>;
              })}
            </Select>
            <h3>Table Size</h3>
            <Radio.Group
              options={[
                ..._.map(TABLE_SIZES, (e) => {
                  return {
                    label: e.charAt(0).toUpperCase() + e.slice(1),
                    value: e,
                  };
                }),
              ]}
              onChange={(e) => {
                this.setState({ tableSize: e.target.value });
              }}
              value={tableSize}
              optionType="button"
              buttonStyle="solid"
            />
          </Modal>
        </div>
      );
    }
  }
}
